<template>
    <div>
        <div class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Credit</th>
                        <th>Adjustment</th>
                        <th>Discount Code</th>
                        <th>Order</th>
                        <th>Refund</th>
                        <th>Reference</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in displayedItems" :key="index">

                        <td><span>{{ user.createdDate | formatDate }}</span></td>
                        <td><span v-if="user.transactionType === 'Credit'">${{ user.amount.toFixed(2) }}</span></td>
                        <td><span v-if="user.transactionType === 'Adjustment'">-${{ user.amount.toFixed(2) }}</span></td>
                        <td><span v-if="user.transactionType === 'Discount Code'">-${{ user.amount.toFixed(2) }}</span></td>
                        <td><span v-if="user.transactionType === 'Order'">-${{ user.amount.toFixed(2) }}</span></td>
                        <td><span v-if="user.transactionType === 'Refund'">${{ user.amount.toFixed(2) }}</span></td>
                        <td><span>{{ user.reference }}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br>
        <br>
        <div v-if="user && user.length > 0" class="col-sm-12 col-md-12">
            <button class="pagination-button" @click="prevPage" :disabled="currentPage === 1">Previous</button>
            <span class="current-page">Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="pagination-button" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
        </div>
    </div>
</template>
  
  
<script>
export default {
    name: 'CreditCard',
    components: {
    },
    props: {
        data: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        quickviewData: {
            type: String,
            default: '',
        },
        inSlider: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        fetchData() {
            const sortOrder = 'decs';
            const sortField = 'createdDate';
            const url = this.productData.endpoint + '/credits/transactions/' + this.productData.customerId + '?token=' + this.productData.token +'&sortOrder='+ sortOrder +'&sortField='+ sortField;
            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    this.user = data.list;
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                });
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        }
    },
    filters: {
        formatDate(dateString) {
            const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            return new Date(dateString).toLocaleDateString(undefined, options);
        },
    },
    data() {
        return {
            user: [], // Initialize an empty array to hold the fetched data
            currentPage: 1,      // Current page
            itemsPerPage: 10
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.productData = JSON.parse(this.data);
            //this.fetchCreditTransaction();
            this.fetchData()
        });
    },
    computed: {
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.user.slice(startIndex, endIndex);
        },
        totalPages() {
            return Math.ceil(this.user.length / this.itemsPerPage);
        }
    }

};


</script>
